module.exports = __webpack_public_path__ + "static/media/simple_gratitudes-480-280.331d2688.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/layout/assets/simple_gratitudes-480-280.png
// module id = 91
// module chunks = 0